export enum NotificationModule {
  ARTICLE = 'article',
  INVOICE = 'invoice',
}
